import { Alert, Autocomplete, Box, Button, Divider, Drawer, FormControl, FormControlLabel, IconButton, InputLabel, LinearProgress, linearProgressClasses, MenuItem, Paper, Select, styled, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { MultiInputDateRangeField } from '@mui/x-date-pickers-pro/MultiInputDateRangeField';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import React, { useEffect, useState } from 'react'
import dayjs, { Dayjs } from 'dayjs';
import { ArrowDropDownIcon, CalendarIcon, DatePicker } from '@mui/x-date-pickers';
import { ApiDownloadFeedbackExcel, ApiGetAreaManager, ApiGetFeedbackQuestions, ApiGetScorecardList, ApiGetTempToken, ApiGetVenueList, ApiGroupMonthReport, ApiRegionVenues, ApiScoreCardPDF, ApiSubmitClientCommmet, ApiSubmitFeedbackAnswers } from '../../apiService/Core/Apicall';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { ArrowOutward, CancelOutlined, FiberManualRecord, WarningAmber } from '@mui/icons-material';
import { CircularProgressbar } from 'react-circular-progressbar';
import scorecard from '../../assets/images/styleimages/ScoreCard.png'
import downlod from '../../assets/aldi/images/DownloadImage.png'
import { RootState } from '../../global/config/store';
import { log } from 'console';
import { setSelectedMonth } from '../../global/config/Reducer/MonthSlice';
import { RegionList, setRegion } from '../../global/config/Reducer/RegionSlice';
import { useNavigate } from 'react-router-dom';
import storage from '../../utils/storage';

function ScoreCard() {
    // debugger
    const selectedMonth = useSelector((state: RootState) => state.month.selectedMonth)
    const dispatch = useDispatch()
    const [DateRange, setDateRange] = useState<any>([
        dayjs().subtract(4, 'month'),
        dayjs()
    ])
    const [month, setmonth] = useState<any>(dayjs(selectedMonth))
    const [ScoreCardlist, setScoreCardlist] = useState<any>([])
    const [venuelist, setvenuelist] = useState<any[]>([])
    const [venues, setvenues] = useState<number | string>()
    const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)
    const Regions = useSelector(RegionList)
    const [selectedRegion, setselectedRegion] = useState<number | ''>(Regions[0]?.regionId ?? '')
    const [showfeedback, setshowfeedback] = useState<boolean>(false)
    const [getquestions, setgetquestions] = useState<any>([])
    const [replies, setreplies] = useState<any>([])
    const [comments, setcomments] = useState<any>([])
    const [selectedreporthdrId, setselectedreporthdrId] = useState<string>()
    const [selectedvenueId, setselectedvenueId] = useState<string>()
    const [shortBy, setshortBy] = useState<string>("Name")
    const [isSubmitTrue, setisSubmitTrue] = useState<boolean>(false)
    const userData = JSON.parse(storage.getItem("userData") || "{}");
    const isClient = storage.getItem('userRole') === 'clientadmin'
    const isManager = storage.getItem('userRole') === 'areaManager'
    const navigate = useNavigate()
    const [isGroupScore, setisGroupScore] = useState<boolean>(false);
    const { clientEntityIds } = useSelector((state: RootState) => state.wholegroup)
    const [area, setSelectedArea] = useState<number | string | null>(null)
    const [Areamanagerlist, setareamanagerlist] = useState<any[]>([])


    useEffect(() => {
        const RegionList = async () => {
            if (storage.getItem("clientEntityId") && storage.getItem('ClientGroupName') === "ALDI") {
                const data = `?clientEntityId=${storage.getItem("clientEntityId")}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
                const response3 = await ApiRegionVenues(data)
                dispatch(setRegion(response3.data))
            }
        }
        clientEntity && RegionList()
    }, [clientEntity])

    useEffect(() => {
        if (Regions?.length > 0) {
            setselectedRegion(Regions[0].regionId);
        }
    }, [Regions, clientEntity]);




    useEffect(() => {

        const GetScoreCard = async () => {
            try {
                const data = `?month=${month.month() + 1}&clientGroupName=${storage.getItem('ClientGroupName')}&year=${month.year()}${venues != 0 ? `&venueId=${venues}` : ''}${selectedRegion ? `&regionId=${selectedRegion}` : ''}&clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')}${(storage.getItem('areaId') || area) ? `&areaId=${area ?? storage.getItem('areaId')}` : ''}`
                const response = await ApiGetScorecardList(data);
                setScoreCardlist(response.data)
            }
            catch (error: any) {
                // toast.error(error)
            }
        }
        if (venues !== undefined && month && clientEntity) { GetScoreCard(); }
    }, [month, venues, clientEntity, area, selectedRegion, isGroupScore])


    useEffect(() => {
        const Venuelist = async () => {
            setvenuelist([])
            try {
                if (!window.location.hostname.includes('aldi')) {
                    const clientEntityId: any = isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')
                    const response = await ApiGetVenueList(clientEntityId, selectedRegion ? String(selectedRegion) : '');
                    const venues = [
                        {
                            venueId: 0,
                            venueName: "All",
                        },
                        ...response.data
                    ]
                    setvenuelist(venues);
                    setvenues(venues[0]?.venueId)
                }
                else if (window.location.hostname.includes('aldi') && selectedRegion) {
                    const finalregion = Regions && Regions.find((region: any) => region.regionId === selectedRegion)?.venues;
                    const aldivenues = [
                        {
                            venueId: 0,
                            venueName: "All",
                        },
                        ...finalregion
                    ]
                    setvenuelist(aldivenues)
                    if (finalregion && finalregion.length > 0) {
                        setvenues(aldivenues[0].venueId)
                    }

                }
            } catch (error: any) {
                // toast.error(error)
            }
        };
        clientEntity && Venuelist();
        clientEntity && fetchAreaManagers();

    }, [clientEntity, selectedRegion, isGroupScore])

    useEffect(() => {
        setmonth(dayjs(selectedMonth))
    }, [selectedMonth])

    const handleOpenNewPage = (item: any, response: any) => {
        // Save the state temporarily (since navigate() can't pass state to a new tab)
        sessionStorage.setItem('viewScorecardData', JSON.stringify({
            item,
            htmlResponse: response?.data,
        }));

        // Open in a new tab
        window.open('/maindashboard/viewscorecard', '_blank');
    };
    const downloadScoreCard = async (item: any, dwc: boolean) => {
        try {
            storage.removeItem('idwc')
            if (dwc) {
                storage.setItem('idwc', "true")
            }
            const data = `?clientEntityId=${storage.getItem('clientEntityId')}&isClientEntityIdRequired=true&venueId=${item.venueId}&allocationId=${item.allocationId}&isHtmlContent=true${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}${dwc ? `&isDownloadWithoutComments=true` : ''}`;
            const response = await ApiScoreCardPDF(data);
            // navigate('/maindashboard/viewscorecard', {state:{item:item, htmlResponse:response?.data}})

            handleOpenNewPage(item, response)
            // const blob = new Blob([response.data], { type: 'application/pdf' });
            // const url = window.URL.createObjectURL(blob);
            // const link = document.createElement('a');
            // link.href = url;

            // link.download = `ScoreCard_${item.venueId}_${item.allocationId}.pdf`;
            // document.body.appendChild(link);
            // link.click();

            // link.remove();
            // window.URL.revokeObjectURL(url);
        } catch (error) {
            alert(error);
        }

    }

    const OpenEditReport = async (item: any) => {
        try {
            const data = {
                reportHeaderId: item.reportHeaderId,
                allocationId: item.allocationId,
                clientGroupName: item.allocationClientGroup
            }
            const res = await ApiGetTempToken(data)
            if (res.success) {
                sessionStorage.setItem('fromOriginalSite', 'true');
                window.open(`${process.env.REACT_APP_API_SHOPPER_API_BASE_URL}?x-z-a=${res?.data?.token}`, '_blank');
            }
        } catch (error: any) {
            toast.error(error.message)
        }
    }

    const HandlegetFeedbackQuestisons = async (reportHdrId: string, venueId: string) => {
        try {
            setselectedreporthdrId(reportHdrId)
            const data = `?clientEntityId=${storage.getItem('clientEntityId')}&isClientEntityIdRequired=true&reportHdrId=${reportHdrId}&venueId=${venueId}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
            const res = await ApiGetFeedbackQuestions(data)
            if (res.status) {
                setgetquestions(res.data)
                const reply = res.data.map((item: any) => ({ "response": item.response, "reportFeedbackQuestionId": item.reportFeedbackQuestionId }))
                const comment = res.data.map((item: any) => ({ "clientComment": item.clientComment, "reportFeedbackQuestionId": item.reportFeedbackQuestionId }))
                setreplies(reply)
                setcomments(comment)

                if (res.data.length > 0) {
                    setshowfeedback(true);
                    // toast.success("Feedback Questions Get Successfully")
                }
                else {
                    toast.warning("No questions found")
                }
            }
        } catch (error: any) {
            const message =
                error?.response?.data?.message || error?.message || String(error);
            toast.error(message);
        }
    }

    const handleSubmitfeedbackquestions = async (finalSubmit: boolean) => {
        if (finalSubmit) {
            const emptyResponses = replies?.filter(
                (item: any) => !item.response || item.response.trim() === ""
            );

            if (emptyResponses.length > 0) {
                toast.error("Please answer all feedback questions before submitting.");
                return; // Stop function execution
            }
        }

        try {
            const data = {
                "reportHdrId": selectedreporthdrId ? parseInt(selectedreporthdrId) : 0,
                "isSubmitTrue": finalSubmit,
                "userId": userData?.userId,
                "clientEntityId": parseInt(storage.getItem('clientEntityId') || '0'),
                "venueId": selectedvenueId ? parseInt(selectedvenueId) : 0,
                "replies": replies

            }
            const res = await ApiSubmitFeedbackAnswers(data)
            setgetquestions([])
            setshowfeedback(false)
        } catch (error: any) {
            const message =
                error?.response?.data?.message || error?.message || String(error);
            toast.error(message);
        }
    }


    const handleSubmitfeedbackcomments = async (reportFeedbackHdrId: number) => {
        const emptyResponses = comments?.filter(
            (item: any) => !item.clientComment || item.clientComment.trim() === ""
        );

        // if (emptyResponses.length > 0) {
        //     toast.error("Please answer all feedback comments before submitting.");
        //     return; // Stop function execution
        // }

        const data = {
            "reportFeedbackHdrId": reportFeedbackHdrId,
            comments
        }
        try {
            const res = await ApiSubmitClientCommmet(data)
            if (res?.status) {
                setgetquestions([])
                setshowfeedback(false)
            }
        } catch (error: any) {
            const message =
                error?.response?.data?.message || error?.message || String(error);
            toast.error(message);
        }
    }


    const handlechnageanswer = (e: any, index: number) => {
        const { value } = e.target
        setreplies((prev: any) =>
            prev.map((question: any, i: number) =>
                i === index ? { ...question, response: value } : question
            ))
    }

    const handlechangeComment = (e: any, index: number) => {
        const { value } = e.target
        setcomments((prev: any) =>
            prev.map((question: any, i: number) =>
                i === index ? { ...question, clientComment: value } : question
            ))
    }

    const handleVenueDashboard = (venueId: string, venueName: string) => {
        if(!venueId){
            return
        }
        const url = `/maindashboard/sitedashboard?v=${encodeURIComponent(venueId)}&n=${encodeURIComponent(venueName)}&s=${encodeURIComponent(selectedMonth)}`;
        window.open(url, '_blank'); // opens in new tab
    };


    const handledownloadExcel = async () => {
        try {
            const query = `?reportMonth=${month.month() + 1}&reportYear=${month.year()}&clientEntityId=${isGroupScore ? clientEntityIds : parseInt(storage.getItem('clientEntityId') || '0')}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`;

            const response = await ApiDownloadFeedbackExcel(query);

            // Create Excel blob
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            if (blob.size === 0) {
                throw new Error("Empty Excel file.");
            }

            // Create download link
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;

            // Add a default filename
            link.setAttribute(
                "download",
                `Custom_Month.xlsx`
            );

            document.body.appendChild(link);
            link.click();

            // Clean up
            link.remove();
            URL.revokeObjectURL(url);
        } catch (error: any) {
            const message = error?.response?.message || error?.message;
            toast.error(message);
        }
    };


    const fetchAreaManagers = async () => {
        try {
            const data = `?offset=0&limit=1000&clientEntityId=${isGroupScore ? clientEntityIds : clientEntity}`
            const response = await ApiGetAreaManager(data)
            setareamanagerlist(response.data)
        } catch (error) {
            console.error('Error fetching area managers:', error)
        }
    }

    return (
        <Box className='w-100 mt-3'>

            <Box className='d-flex flex-wrap-reverse align-items-center justify-content-between'>
                <Typography className='fw-bold' variant='h5'> Results</Typography>
                {(storage.getItem("ClientGroupName") === "MM" || storage.getItem("ClientGroupName") ===  "EXTENDED" || storage.getItem("ClientGroupName") === "JBHIFI") && storage.getItem('userRole') === 'clientadmin' && (
                    <Box>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={isGroupScore}
                                    onChange={(e) => {setSelectedArea(null); setisGroupScore(e.target.checked)}}
                                />
                            }
                            label={"Whole Group"}
                        />
                    </Box>)}
                <Box className='d-flex col-md-auto col-12 flex-wrap align-items-center  p-0 m-0 justify-content-end' gap={1}>
                    {/* <Box className='col-7 p-0 col-md-6 justify-content-end d-flex'> */}
                    <Button className='btn-main' onClick={() => { handledownloadExcel() }}>Download Feedback Excel</Button>
                    {window.location.hostname.includes('aldi') && (
                        <FormControl sx={{ width: 'auto' }} className='justify-content-end text-end'>
                            <InputLabel id="demo-simple-select-label">Region</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                label='Region'
                                id="demo-simple-select"
                                defaultValue={Regions[0]?.regionId}
                                value={selectedRegion}
                                onChange={(e: any) => { setselectedRegion(e?.target?.value) }}
                            >
                                {Regions && Regions?.map((item: any, index: number) => (
                                    <MenuItem key={index} value={item?.regionId}>
                                        {item?.regionName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                    {storage.getItem('userRole') === 'clientadmin' && storage.getItem('ClientGroupName') !== "ALDI" && (
                        <FormControl sx={{ width: 'fit-content', minWidth: '200px' }}>
                            {/* <InputLabel id="demo-simple-select-label" shrink={false}>Venues:</InputLabel> */}
                            <Autocomplete
                                className='text-dark'
                                options={Areamanagerlist || []}
                                getOptionLabel={(option) => option?.areaName || ''}
                                disabled={isGroupScore}
                                value={Areamanagerlist?.find((item) => item.areaId === area) || null}
                                onChange={(event, newValue) => {
                                    setSelectedArea(newValue?.areaId || '');
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Area" sx={{ color: 'black !important' }} variant="outlined" />
                                )}

                                isOptionEqualToValue={(option, value) => option.areaId === value.areaId}
                            />
                        </FormControl>
                    )}
                    <FormControl sx={{ width: 'fit-content', minWidth: "200px" }}>
                        {/* <InputLabel id="demo-simple-select-label" shrink={false}>Venues:</InputLabel> */}
                        <Autocomplete
                            className='text-dark'
                            options={venuelist || []}
                            getOptionLabel={(option) => option.venueName || ''}
                            value={venuelist.find((item) => item.venueId === venues) || 0}
                            onChange={(event, newValue) => {
                                setvenues(newValue?.venueId || '');
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label="Sites" sx={{ color: 'black !important' }} variant="outlined" />
                            )}

                            isOptionEqualToValue={(option, value) => option.venueId === value.venueId}
                        />
                    </FormControl>
                    <FormControl sx={{ width: 'fit-content', minWidth: "200px" }}>
                        {/* <InputLabel id="demo-simple-select-label" shrink={false}>Venues:</InputLabel> */}
                        <Autocomplete
                            className="text-dark"
                            options={["Name", "Score"]}
                            value={shortBy}
                            onChange={(event, newValue) => {
                                setshortBy(newValue || ""); // handle null case
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Sort By"
                                    variant="outlined"
                                    sx={{
                                        '& .MuiInputLabel-root': { color: 'black' },
                                        '& .MuiOutlinedInput-root': { color: 'black' }
                                    }}
                                />
                            )}
                        />
                    </FormControl>
                    {/* </Box> */}
                    {/* <Box className='col-md-6 p-0 col-5 d-flex justify-content-end'> */}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker value={month}
                            sx={{ maxWidth: "120px" }}
                            views={['month', 'year']}
                            format="MMM-YY"
                            label='Month'
                            onChange={(e: any) => {
                                const isoString = e?.startOf('month').toISOString();
                                dispatch(setSelectedMonth(isoString));
                            }}
                            slots={{
                                openPickerIcon: ArrowDropDownIcon,
                            }}
                        />
                    </LocalizationProvider>
                    {/* </Box> */}
                </Box>
            </Box>
            <Box className='mt-4 mx-2'>
                <Alert
                    severity="info"
                    sx={{
                        backgroundColor: '#e8f4fd',
                        color: '#0d3c61',
                        borderRadius: '10px',
                        py: 0.8,
                        px: 2,
                        border: '1px solid #b3d4ff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        minHeight: '52px',
                        '& .MuiAlert-message': {
                            display: 'flex',
                            width: '100%',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            flexWrap: 'nowrap',
                            py: 0
                        },
                        '& .MuiAlert-icon': {
                            color: '#1976d2',
                            fontSize: '22px',
                            display: 'flex',
                            alignItems: 'center',
                            py: 0
                        }
                    }}
                >
                    <Typography variant="body1" sx={{ fontWeight: 500, fontSize: '16px', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.5 }}>
                        To download your results please click on arrow button
                        <ArrowOutward sx={{ fontSize: '20px', display: 'inline-flex', border: '1px solid #0d3c61', borderRadius: '4px', p: '2px', backgroundColor: 'white', color: '#0d3c61', verticalAlign: 'middle', ml: 0.5 }} />
                    </Typography>
                </Alert>
            </Box>
            <Box className='d-flex flex-wrap mb-3 align-items-center ms-2 mt-4' gap={3}>
                {ScoreCardlist.length > 0 ? (
                    (shortBy === "Name"
                        ? ScoreCardlist.sort((a: any, b: any) => a.venueName.localeCompare(b.venueName))
                        : ScoreCardlist.sort((a: any, b: any) => a.Score - b.Score)
                    ).map((item: any, index: number) => (
                        <Box width={{ xs: '100%', md: '32%' }} className='bg-light-main border-20'>
                            <Box className='d-flex align-items-start pe-3 justify-content-between'>
                                <Typography
                                    sx={{
                                        background: `url(${scorecard})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover',
                                        backgroundPosition: 'center', zIndex: '99'
                                    }}
                                    className='fw-bold   pt-1 pb-4 pl-0 pl-2 pr-4 '
                                    variant='subtitle2'>{item?.statusDesc === 'Approve to client' ? "Approved" : item?.statusDesc}</Typography>
                                <Box className='d-flex justify-content-end' gap={2}>
                                    <Tooltip title="Download Report" placement="top" arrow>
                                        <IconButton onClick={() => { downloadScoreCard(item, false) }} sx={{ border: '1px solid black' }} className='p-3 border-20 mt-3'>
                                            <ArrowOutward />
                                        </IconButton>
                                    </Tooltip>
                                    {storage?.getItem("dwc") === "1" && (
                                        <IconButton
                                            onClick={() => downloadScoreCard(item, true)}
                                            sx={{ border: "1px solid black" }}
                                            className="p-3 border-20 mt-3"
                                        >
                                            <Typography>WC</Typography>
                                        </IconButton>
                                    )}
                                </Box>
                            </Box>
                            <Box className='p-3'>
                                <Typography style={{ cursor: "pointer" }} onClick={() => { handleVenueDashboard(item?.venueId, item?.venueName) }} className='fw-bold w-50 mb-1' variant='h6'>{item.venueName} {item?.fleetNo ? `(FleetNo: ${item?.fleetNo})` : ''}</Typography>
                                <Box className='d-flex align-ites-center justify-content-between '>
                                    <Box>
                                        {/* <Typography variant='caption'>Task Date: {new Date(item?.inspectionDateTime).toLocaleDateString('en-GB', {
                                            day: '2-digit',
                                            month: 'short',
                                            year: 'numeric'
                                        })}</Typography> */}
                                        <Typography className='fw-bold my-1' variant='h6'>
                                            {/* {new Date(item?.Date)
                                        .toLocaleDateString('en-GB', {
                                            month: 'short',
                                            year: '2-digit'
                                        })} */}
                                            {dayjs(month).format('MMM')}-{dayjs(month).format('YY')}
                                        </Typography>
                                        <Box className='d-flex' gap={1}>
                                            {storage.getItem('userRole') === 'clientadmin' && item?.statusDesc !== 'Released' && item?.canClientEditReports && (<Button className='button-dark-outlined border-10 px-3 py-1' variant='outlined' onClick={() => { OpenEditReport(item) }}>Edit</Button>)}
                                            {!isClient && !isManager && storage.getItem('ClientGroupName') !== 'TRANSPORT' && (<Button className='button-dark-outlined border-10 px-3 py-1' sx={{ textTransform: 'none' }} variant='outlined' onClick={() => { HandlegetFeedbackQuestisons(item?.reportHeaderId, item?.venueId); setselectedvenueId(item?.venueId) }}>Feedback</Button>)}
                                            {(isClient || isManager) && storage.getItem('ClientGroupName') !== 'TRANSPORT' && (<Button className='button-dark-outlined border-10 px-3 py-1 d-flex align-items-center gap-2' sx={{ textTransform: 'none' }} variant='outlined' onClick={() => {
                                                if (item?.feedbackStatus !== "pending") { HandlegetFeedbackQuestisons(item?.reportHeaderId, item?.venueId); setselectedvenueId(item?.venueId) } else { toast.error("Feedback is not submmited yet") }
                                            }}><span>View Feedback</span> <FiberManualRecord sx={{ fontSize: "10px", color: item?.feedbackStatus == 'pending' ? 'red' : item?.feedbackStatus == 'incomplete' ? 'orange' : 'green' }} /></Button>)}
                                        </Box>
                                    </Box>
                                    <Box className='p-m medium'>
                                        <CircularProgressbar
                                            text={`${item?.Score}%`}
                                            strokeWidth={20}
                                            value={item?.Score}

                                        />

                                    </Box>
                                </Box>
                                <Divider className='w-100 my-3' sx={{ borderStyle: 'dashed !important', border: '1px solid black' }} />
                                {/* 
                            <Box className='d-flex align-items-stertch justify-content-center gap-1'>
                                <Box maxWidth='32%' className='flex-grow-1 txt-white border-20 bg-main px-3 py-2'>
                                    <Typography variant='caption'>Download <br /> Date</Typography>
                                    <Typography className='fw-bold mt-3' fontSize={{ xs: "14px", md: '17px' }}>
                                        {item?.downloadDate ? new Date(item?.downloadDate).toLocaleDateString('en-GB', {
                                            day: '2-digit',
                                            month: 'numeric',
                                            year: 'numeric',
                                            timeZone: 'UTC',
                                        }) : 'N/A'}
                                    </Typography>
                                </Box>
                                <Box maxWidth='32%' className='flex-grow-1  border-20 bg-secondary px-3 py-2'>
                                    <Typography variant='caption'>Submit <br /> Date </Typography>
                                    <Typography className='fw-bold mt-3' fontSize={{ xs: "14px", md: '17px' }}>{item?.submitDate ? new Date(item?.submitDate).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: 'numeric',
                                        year: 'numeric',
                                        timeZone: 'UTC',
                                    }) : 'N/A'}</Typography>
                                </Box>
                                <Box maxWidth='32%' className='flex-grow-1 border-20 bg-third px-3 py-2'>
                                    <Typography variant='caption'>Days <br /> Pending</Typography>
                                    <Typography className='fw-bold mt-3' fontSize={{ xs: "14px", md: '17px' }}>{item?.pendingDays ? new Date(item?.pendingDays).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: 'numeric',
                                        year: 'numeric',
                                        timeZone: 'UTC',
                                    }) : 'N/A'}</Typography>
                                </Box>
                            </Box> */}
                                <Box className='d-flex align-items-stertch justify-content-center gap-1'>
                                    {item?.lastReports.map((items: any, index: number) => (
                                        <Box maxWidth='32%' key={index} className={`flex-grow-1 txt-white border-20 ${index === 1 ? 'bg-secondary' : index === 2 ? 'bg-third' : 'bg-main'} px-3 py-2`}>
                                            <Typography variant='body1'>{dayjs().month(items?.month - 1).format("MMM")}-{dayjs().year(items?.year).format('YY')}</Typography>
                                            <Typography className='fw-bold mt-3' fontSize={{ xs: "14px", md: '17px' }}>
                                                {items?.Score ? `${items?.Score}%` : 'N/A'}
                                            </Typography>
                                        </Box>

                                    ))}
                                </Box>
                            </Box>
                        </Box>

                    ))) : <Typography className='mx-auto text-center text-dark my-5' variant='h5'>Scorecards for this month are currently unavailable. Please check back later or view those from the previous month.</Typography>}
            </Box>
            <Drawer
                anchor={'right'}
                open={showfeedback}
            // onClose={toggleDrawer(anchor, false)}
            >
                <Box className=' h-100 p-3 pt-0 d-flex flex-column' minWidth={'300px'} width={'600px'} bgcolor={'white'}>
                    {/* <Box bgcolor={'white'} className='p-2' position={'sticky'} top={0} zIndex={2}> */}
                    <Box className='d-flex justify-content-between'>
                        <Typography variant='h5' className='fw-bold'>Feedback</Typography>
                        <IconButton onClick={() => { setshowfeedback(false) }}><CancelOutlined /></IconButton>
                    </Box>
                    <hr className='mt-1 mb-4' />
                    {/* </Box> */}
                    <Box overflow={'auto'} className='flex-1'>
                        {getquestions?.map((item: any, index: number) => (
                            <Box className='d-flex  gap-1 mb-2'>
                                <Typography className='fw-bold' variant='body1'>Q{index + 1}.</Typography>
                                <Box className='w-100'>
                                    <Typography className='fw-bold' variant='body1'>
                                        <span>{item?.questions}</span>
                                    </Typography>
                                    <TextField disabled={isClient || isManager} onChange={(e) => { handlechnageanswer(e, index) }} multiline minRows={3} className='mt-2 bg-light' placeholder='write your answer here...' fullWidth sx={{ "input": { fontSize: '14px !important' }, "& .MuiOutlinedInput-root": { borderRadius: '10px !important' } }} value={replies[index].response} />

                                    {(isClient || isManager || item?.clientComment?.length > 0) && (<Box className='mt-3 mb-4'>
                                        <InputLabel sx={{ fontSize: '14px' }} className='mb-1 pb-0'>Comment:</InputLabel>
                                        <TextField disabled={!isClient && !isManager} onChange={(e) => { handlechangeComment(e, index) }} multiline minRows={3} className='mt-0 bg-light' placeholder='write your answer here...' fullWidth sx={{ "input": { fontSize: '14px !important' }, "& .MuiOutlinedInput-root": { borderRadius: '10px !important' } }} value={comments?.[index]?.clientComment} />
                                    </Box>
                                    )}
                                </Box>
                            </Box>
                        ))}
                    </Box>
                    <Box className='gap-2 mt-auto' display={(isClient || isManager) ? 'none' : 'flex'}>
                        <Button className=' btn-outlined flex-grow-1' variant='outlined' onClick={() => { handleSubmitfeedbackquestions(false) }}>Save & Close</Button>
                        <Button className='btn-main flex-grow-1' onClick={() => { handleSubmitfeedbackquestions(true) }}>Submit</Button>
                    </Box>
                    <Box className='gap-2 mt-auto' display={(isClient || isManager) ? 'flex' : 'None'}>
                        <Button className='btn-main flex-grow-1' onClick={() => { handleSubmitfeedbackcomments(getquestions?.[0]?.reportFeedbackHdrId) }}>Submit</Button>
                    </Box>
                </Box>
                {/* {list(anchor)} */}
            </Drawer>
        </Box>
    )
}

export default ScoreCard
